import TaskRecord from './TaskRecord';

class ConstructionalPraxisRecallTaskRecord extends TaskRecord {

    constructor() {
        super()
        this.taskType = 'ConstructionalPraxisRecall'
        this.drawings = null
    }

    parseLogExtra(logJson) {
        if (!logJson) return
        this.drawings = logJson['Drawings']
    }

    //--
}

export default ConstructionalPraxisRecallTaskRecord;